module.exports = {
        srcSet: __webpack_public_path__ + "assets/images/free-coin-43d8da4407ae3b5e.png"+" 972w",
        images: [{path: __webpack_public_path__ + "assets/images/free-coin-43d8da4407ae3b5e.png",width: 972,height: 396}],
        src: __webpack_public_path__ + "assets/images/free-coin-43d8da4407ae3b5e.png",
        toString: function(){return __webpack_public_path__ + "assets/images/free-coin-43d8da4407ae3b5e.png"},
        
        width: 972,
        height: 396
      }